import { Box, Button, Divider, Grid, Skeleton, Typography } from '@mui/material'
import React, { useMemo } from 'react'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { getTutorials } from 'src/redux/slices/user'
import Iconify from '../Iconify'
import useLocales from 'src/hooks/useLocales'
import { get, isEmpty } from 'lodash'
import TutorialCard from './TutorialCard'

function TutorialsCard({ lang }) {
    const { translate } = useLocales()
    const user = useSelector(state => state.user.user)


    const { data, isLoading } = useQuery(['tutorials'], () => getTutorials(user?.id), {
        staleTime: 100 * 60 * 1000,
        cacheTime: 100 * 60 * 1000,
        keepPreviousData: true,
    })


    let videos = useMemo(() => {
        let tutorials = data?.data ?? []

        if (isEmpty(data)) return []

        try {
            let mapped = tutorials.videos.map(v => v?.[lang] ?? v['en'])

            return mapped

        } catch (error) {
            return []
        }

    }, [data?.data, lang])

    let playlist_url = get(data, 'data.playlist_url')


    return (
        <>
            {
                playlist_url &&
                <>
                    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>

                        <Typography variant='h5'>

                        </Typography>
                        <Button component='a' size='small' startIcon={<Iconify icon='solar:playlist-bold'></Iconify>} href={playlist_url} target='_blank'>{translate('watchMoreVideos')}</Button>


                    </Box>
                    <Divider sx={{ mt: 1, mb: 2 }}></Divider>
                </>
            }
            <Grid container spacing={2} >

                {videos.map(item => (
                    <Grid item md={4} sm={12} xs={12}>
                        {isLoading ?
                            <Skeleton width={'100%'} height={'300px'} variant='rectangular' sx={{ borderRadius: 1 }} />
                            :
                            <TutorialCard item={item}></TutorialCard>}

                    </Grid>
                ))}
            </Grid>
        </>
    )
}


export default TutorialsCard